import { Component, Input } from '@angular/core';
import { faCircleInfo, faLock } from '@fortawesome/free-solid-svg-icons';

/**
 * ENT-16431 — reusable, schema-driven label for a single MI (cost centre) field.
 * Renders the spec affordances from the field metadata alone so every MI card
 * (question, defaults, recap) shows them identically:
 *  - the field name,
 *  - a required asterisk when `mandatory`,
 *  - an info-bubble (fa-icon) with the configured `description` on hover,
 *  - a lock icon when the value is `locked` (defaulted / not editable).
 */
@Component({
  selector: 'app-chat-mi-field-label',
  standalone: false,
  templateUrl: './chat-mi-field-label.component.html',
  styleUrls: ['./chat-mi-field-label.component.scss']
})
export class ChatMiFieldLabelComponent {
  @Input() name = '';
  @Input() mandatory?: boolean;
  @Input() description?: string;
  @Input() locked?: boolean;

  faCircleInfo = faCircleInfo;
  faLock = faLock;
}
